import React from "react";
import DateTimeInput from "../fields/DateTimeInput";

const EMSCPRSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>2-2. 구급대원 현장 심폐소생술</h3>

      {/* 구급대원 흉부압박 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">구급대원 흉부압박</label>
          <div className="input_2col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="EMS_CPR"
                name="EMS_CPR"
                value="예"
                checked={formData.EMS_CPR === "예"}
                onChange={(e) =>
                  setFormData({ ...formData, EMS_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">예</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="EMS_CPR"
                name="EMS_CPR"
                value="아니오"
                checked={formData.EMS_CPR === "아니오"}
                onChange={(e) =>
                  setFormData({ ...formData, EMS_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">아니오</div>
            </label>
          </div>
        </div>

        {formData.EMS_CPR === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">구급대원 흉부압박 시각</label>
            <div className="input_2col">
              <DateTimeInput
                id="EMS_CPR_time"
                value={formData.EMS_CPR_time || ""}
                onChange={(datetime) =>
                  setFormData({ ...formData, EMS_CPR_time: datetime })
                }
              />
            </div>
          </div>
        )}
      </div>

      {/* Mechanical CPR device 적용 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Mechanical CPR device 적용</label>
          <div className="input_1col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="Mech_CPR"
                name="Mech_CPR"
                value="예"
                checked={formData.Mech_CPR === "예"}
                onChange={(e) =>
                  setFormData({ ...formData, Mech_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">예</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="Mech_CPR"
                name="Mech_CPR"
                value="아니오"
                checked={formData.Mech_CPR === "아니오"}
                onChange={(e) =>
                  setFormData({ ...formData, Mech_CPR: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">아니오</div>
            </label>
          </div>
        </div>
      </div>

      {/* 첫 리듬 */}
      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">첫 리듬</label>
          <div className="input_1col">
            {[
              "VF",
              "pVT",
              "PEA",
              "asystole",
              "shockable",
              "non-shockable",
              "not obtained",
              "맥박 촉지됨",
            ].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_1st_rhythm"
                  name="EMS_1st_rhythm"
                  value={value}
                  checked={formData.EMS_1st_rhythm === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_1st_rhythm: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 첫 리듬 시각 및 관찰자 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">첫 리듬 시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="EMS_1st_rhythm_time"
              value={formData.EMS_1st_rhythm_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, EMS_1st_rhythm_time: datetime })
              }
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">첫 리듬 관찰자</label>
          <div className="input_2col">
            {["병원의료진", "구급대원", "기타"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_1st_rhythm_by"
                  name="EMS_1st_rhythm_by"
                  value={value}
                  checked={formData.EMS_1st_rhythm_by === value}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      EMS_1st_rhythm_by: e.target.value,
                    })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        <div className="block-2column">
          <label className="item_title_2col">구급대원 제세동</label>
          <div className="input_2col">
            {[
              "제세동 시행함",
              "심전도 분석결과 shock 권고되지 않음",
              "심전도 분석 시행하지 않음",
            ].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_shock"
                  name="EMS_shock"
                  value={value}
                  checked={formData.EMS_shock === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_shock: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* 제세동 관련 필드들 */}
      {formData.EMS_shock === "제세동 시행함" && (
        <>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">구급대원 첫 제세동 시각</label>
              <div className="input_2col">
                <DateTimeInput
                  id="EMS_shock_time"
                  value={formData.EMS_shock_time || ""}
                  onChange={(datetime) =>
                    setFormData({ ...formData, EMS_shock_time: datetime })
                  }
                />
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">
                구급대원 제세동 성공 여부
              </label>
              <div className="input_2col">
                {["예", "아니오"].map((value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      id="EMS_shock_success"
                      name="EMS_shock_success"
                      value={value}
                      checked={formData.EMS_shock_success === value}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          EMS_shock_success: e.target.value,
                        })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                구급대원 첫 제세동 에너지
              </label>
              <div className="input-with-unit">
                <input
                  type="text"
                  id="EMS_shock_energy"
                  value={formData.EMS_shock_energy || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      EMS_shock_energy: e.target.value,
                    })
                  }
                />
                <span className="unit-text">J</span>
              </div>
            </div>

            <div className="block-2column">
              <label className="item_title_2col">구급대원 제세동 횟수</label>
              <div className="input-with-unit">
                <input
                  type="text"
                  id="EMS_shock_number"
                  value={formData.EMS_shock_number || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      EMS_shock_number: e.target.value,
                    })
                  }
                />
                <span className="unit-text">회</span>
              </div>
            </div>
          </div>
        </>
      )}

      {/* 기관삽관 관련 필드들 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">구급대원 기관삽관</label>
          <div className="input_2col">
            {["기관삽관", "대체 기도기 사용", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_airway"
                  name="EMS_airway"
                  value={value}
                  checked={formData.EMS_airway === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_airway: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {(formData.EMS_airway === "기관삽관" ||
          formData.EMS_airway === "대체 기도기 사용") && (
          <div className="block-2column">
            <label className="item_title_2col">전문기도유지기 삽입 시각</label>
            <div className="input_2col">
              <DateTimeInput
                id="advanced_airway_time"
                value={formData.advanced_airway_time || ""}
                onChange={(datetime) =>
                  setFormData({ ...formData, advanced_airway_time: datetime })
                }
              />
            </div>
          </div>
        )}
      </div>

      {/* 정맥로 확보 및 수액 투여 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">구급대원 정맥로 확보</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_iv"
                  name="EMS_iv"
                  value={value}
                  checked={formData.EMS_iv === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_iv: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {formData.EMS_iv === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">
              응급실 내원 전 수액 투여량
            </label>
            <div className="input-with-unit">
              <input
                type="text"
                id="EMS_fluid"
                value={formData.EMS_fluid || ""}
                onChange={(e) =>
                  setFormData({ ...formData, EMS_fluid: e.target.value })
                }
              />
              <span className="unit-text">ml</span>
            </div>
          </div>
        )}
      </div>

      {/* 에피네프린 투여 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">구급대원 에피네프린 투여</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_epi"
                  name="EMS_epi"
                  value={value}
                  checked={formData.EMS_epi === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_epi: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {formData.EMS_epi === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">
              구급대원 에피네프린 투여 시각
            </label>
            <div className="input_2col">
              <DateTimeInput
                id="EMS_epi_time"
                value={formData.EMS_epi_time || ""}
                onChange={(datetime) =>
                  setFormData({ ...formData, EMS_epi_time: datetime })
                }
              />
            </div>
          </div>
        )}
      </div>

      {/* 아미오다론 투여 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">구급대원 아미오다론 투여</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="EMS_amio"
                  name="EMS_amio"
                  value={value}
                  checked={formData.EMS_amio === value}
                  onChange={(e) =>
                    setFormData({ ...formData, EMS_amio: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {formData.EMS_amio === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">
              구급대원 아미오다론 투여 시각
            </label>
            <div className="input_2col">
              <DateTimeInput
                id="EMS_amio_time"
                value={formData.EMS_amio_time || ""}
                onChange={(datetime) =>
                  setFormData({ ...formData, EMS_amio_time: datetime })
                }
              />
            </div>
          </div>
        )}
      </div>

      {/* 병원 도착 전 자발순환 회복 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">병원 도착 전 자발순환 회복</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="Pre_ROSC"
                  name="Pre_ROSC"
                  value={value}
                  checked={formData.Pre_ROSC === value}
                  onChange={(e) =>
                    setFormData({ ...formData, Pre_ROSC: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {formData.Pre_ROSC === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">
              병원 도착 전 자발순환 회복 시각
            </label>
            <div className="input_2col">
              <DateTimeInput
                id="Pre_ROSC_time"
                value={formData.Pre_ROSC_time || ""}
                onChange={(datetime) =>
                  setFormData({ ...formData, Pre_ROSC_time: datetime })
                }
              />
            </div>
          </div>
        )}
      </div>

      {/* 병원 도착 전 심폐소생술 중단 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            병원 도착 전 심폐소생술 중단
          </label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  id="Pre_stop_CPR"
                  name="Pre_stop_CPR"
                  value={value}
                  checked={formData.Pre_stop_CPR === value}
                  onChange={(e) =>
                    setFormData({ ...formData, Pre_stop_CPR: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>

        {formData.Pre_stop_CPR === "예" && (
          <div className="block-2column">
            <label className="item_title_2col">
              병원 도착 전 심폐소생술 중단 이유
            </label>
            <div className="input_2col">
              {["ROSC", "CPR에 반응없음", "DNR"].map((value) => (
                <label key={value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    id="Pre_stop_CPR_cause"
                    name="Pre_stop_CPR_cause"
                    value={value}
                    checked={formData.Pre_stop_CPR_cause === value}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        Pre_stop_CPR_cause: e.target.value,
                      })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{value}</div>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default EMSCPRSection;
